export const MAILBOXES = [
  { id: 'customers', label: 'Customers', description: 'Service contracts & repairs' },
  { id: 'franklin', label: 'Franklin', description: 'Franklin sites' },
  { id: 'cspire', label: 'C Spire', description: 'C Spire work orders' }
];

export const SYSTEM_FOLDER_ORDER = { inbox: 0, completed: 1, starred: 2 };

export const SMART_FILTER_FIELDS = [
  { key: 'isPriority', label: 'Repair / priority call', type: 'tri' },
  { key: 'isWarranty', label: 'Warranty call', type: 'tri' },
  { key: 'hasInvoiceNumber', label: 'Has invoice #', type: 'tri' },
  { key: 'hasServiceMonth', label: 'Contract cycle row', type: 'tri' },
  { key: 'addedToQuickbooks', label: 'Added to QuickBooks', type: 'tri' },
  { key: 'isStarred', label: 'Starred', type: 'tri' },
  { key: 'completedDateFrom', label: 'Completed on/after', type: 'date' },
  { key: 'completedDateTo', label: 'Completed on/before', type: 'date' }
];

// Zero-inbox style scoping for manual/smart folders — controls whether an
// item disappears from the folder once it's finalized (billed), the same way
// Inbox and Starred drain automatically as work gets done.
export const FOLDER_SCOPES = [
  {
    id: 'active',
    label: 'Active (drains like Inbox)',
    description: 'Items disappear from this folder once marked Finalized — good for working queues.'
  },
  {
    id: 'archive',
    label: 'Archive (like Completed)',
    description: 'Only shows items after they\u2019re finalized — good for historical/reporting views.'
  },
  {
    id: 'all',
    label: 'All (ignores finalized status)',
    description: 'Shows matching items whether or not they\u2019ve been finalized — good for standing tags like "VIP".'
  }
];

export const CHECKLIST_STEPS_BY_MAILBOX = {
  customers: [
    { key: 'invoiceNumber', label: 'Add invoice #' },
    { key: 'addedToQuickbooks', label: 'Add to QuickBooks' },
    { key: 'printed', label: 'Print' },
    { key: 'complete', label: 'Complete' }
  ],
  franklin: [
    { key: 'invoiceNumber', label: 'Add invoice #' },
    { key: 'addedToQuickbooks', label: 'Add to QuickBooks' },
    { key: 'printed', label: 'Print' },
    { key: 'franklinSentAt', label: 'Sent' },
    { key: 'complete', label: 'Complete' }
  ],
  cspire: [
    { key: 'invoiceNumber', label: 'Add invoice #' },
    { key: 'addedToQuickbooks', label: 'Add to QuickBooks' },
    { key: 'printed', label: 'Print' },
    { key: 'cspireSentAt', label: 'Sent' },
    { key: 'complete', label: 'Complete' }
  ]
};
